import { Container, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from "react-redux"
import CBClientes from "../CBClientes"
import { useDispatch } from "react-redux"
import TClientes from "../TClientes"
import { obtenerClientesCotizadorAction, obtenerClientesCotizadorAllAction } from "../../../ducks/cotizadorDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useEffect } from "react"
import { catRoles } from "../../../constant/catRoles";
import ModalFormCliente from "../ModalFormCliente";
export const styles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    marginBotom: {
        marginBottom: "1rem"
    },
    centerContent: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    }
}))

export const Cotizador = () => {
    const classes = styles()
    const dispatch = useDispatch()
    const { cliente, idCliente } = useSelector(store => store.cotizador)
    const { profile } = useSelector(store => store.logeo)
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerClientesCotizadorAction()).then(Response => {
            dispatch(obtenerClientesCotizadorAllAction())
            dispatch(offLoadAction())
        })
    }, [dispatch])
    return (
        <Container maxWidth="xl">
            <Grid container>
                {
                    (profile.Rol?.Id === catRoles.DEVELOPER) &&
                    <Grid item xs={12}>
                        Clinete target: {cliente.Nombre}
                        <br />
                        Clinete target: {idCliente}
                        <br />
                        Agente ID: {profile.Id}
                        <br />s
                        Agente Mail: {profile.Email}
                    </Grid>
                }

                <Grid item xs={8} alignContent="center">
                    <div className={`${classes.marginBotom}`}>
                        <CBClientes />
                    </div>
                </Grid>
                <Grid item xs={4} alignContent="center">
                    <div className={`${classes.centerContent} ${classes.marginBotom}`}>
                        <ModalFormCliente />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.marginSpace}>
                        <TClientes />
                    </div>
                </Grid>
            </Grid>
        </Container>
    )
}
export default Cotizador